import React from 'react';
import LogsComponent from './components/logs';

const Logs = () => <LogsComponent />;
export default Logs;
